import { Category, EntityTypes, JobOrder, Note, ToManyRef } from "@bullhorn/bullhorn-types";
import { AppBridge, AppBridgeService, Helpers, IDataTableFilter, RemoteDataTableService } from "novo-elements";
import { Observable, from, of } from "rxjs";
import { Where } from '@bullhorn/taurus';
import { HttpService } from "./httpNoteCard.service";
import { ActivatedRoute } from "@angular/router";

export class NoteCardRemoteDataTableService extends RemoteDataTableService<JobOrder> {
  public url: string;
  public additionalFilters: any = {};
  public jobCategories: Category[] = [];
  public candidateIds: number[] = [];

  constructor(private httpService: HttpService, private route: ActivatedRoute) {
    super();
  }

  public getTableResults(
    sort: { id: string; value: string; transform?: Function },
    filter: IDataTableFilter | IDataTableFilter[],
    page: number,
    pageSize: number,
    globalSearch?: string,
  ): Observable<{ results: Note[]; total: number }> {
    const whereQuery: string = this.buildWhereClause(filter);
    const sortQuery: string = this.buildSortColumn(sort);
    const pageQuery: number = this.buildStart(page, pageSize);
    return from(this.getData(whereQuery, pageSize, sortQuery, pageQuery, filter));
    
  }

  private async getData(whereQuery, pageSize, sortQuery, pageQuery, filter): Promise<{ results: JobOrder[]; total: number }> {

    this.additionalFilters = { [this.getIdFilter()]: this.getFilterValue(), ...this.additionalFilters };
    whereQuery = this.buildWhereClause(filter);
    const submissionFields = 'id,action,comments,commentingPerson(firstName,lastName),clientContacts,candidates,jobOrders,leads(firstName,lastName),opportunities(id,title),placements(id, candidate, jobOrder),personReference,dateAdded';
    const response = await this.httpService.search(EntityTypes.Note, whereQuery, submissionFields, 'full', pageSize, sortQuery, pageQuery);

    return {results: response.data, total: response.total};
  }

  private getIdFilter = () => {
    const entityType = this.route.snapshot.queryParamMap.get('EntityType');
    switch (entityType?.toLowerCase()) {
      case 'candidate':
        return `candidateUserID`;
        case 'client':
        case 'client contact':
          return `clientContactUserID`;
        case 'job posting':
          return `jobOrderID`;
      default:
        return ``;
    }
  }

  private getFilterValue = () => {
    const entityType = this.route.snapshot.queryParamMap.get('EntityType');
    switch (entityType?.toLowerCase()) {
      case 'candidate':
        return this.route.snapshot.queryParamMap.get('EntityID');
        case 'client':
          return encodeURIComponent(`^(clientCorporationID=${this.route.snapshot.queryParamMap.get('EntityID')})`);
        case 'client contact':
          return this.route.snapshot.queryParamMap.get('EntityID');
        case 'job posting':
          return this.route.snapshot.queryParamMap.get('EntityID');
      default:
        return ``;
    }
  }

  private buildWhereClause(filter: IDataTableFilter | IDataTableFilter[]): string {
    const query: any = {};
    if (filter) {
      const filters = Helpers.convertToArray(filter);
      filters.forEach((aFilter) => {
        if(aFilter.id === 'clientCorporation') {
          query['jobOrder.clientCorporation'] = aFilter.transform(aFilter.value);
        } else {
          query[aFilter.id] = aFilter.transform ? aFilter.transform(aFilter.value) : aFilter.value;
        }
      });
    }

    console.log(this.additionalFilters);
    return (
      {
        status: {not: 'Archive'}, 
        ...query, 
         ...this.additionalFilters
      });
  }

  private buildSortColumn(sort: { id: string; value: string; transform?: Function }): string {
    if (sort) {
      let value = sort.id;
      if (sort.transform) {
        value = sort.transform(value);
      }
      return sort.value === 'asc' ? value : `-${value}`;
    }
    return '-dateAdded';
  }

  private buildStart(page: number, pageSize: number): number {
    return (page || 0) * pageSize;
  }

}